import React from "react";
import BacklinksOverview from "../../containers/Backlinks/BacklinksOverview";
import BacklinksTabs from "../../containers/Backlinks/BacklinksTabs";
import "./Backlinks.less";

const BacklinksLayout = props => {
  return (
    <div className="backlinks">
      <div className="backlinks-overview">
        <BacklinksOverview domain={props.domain} />
      </div>
      <div className="backlinks-tabs">
        <BacklinksTabs domain={props.domain} />
      </div>
    </div>
  );
};

export default BacklinksLayout;
